const FOLLOW_CRAFT_TYPE_LABELS = {
  1: '去支撑',
  2: '喷砂',
  3: '攻牙',
  4: '牙套',
  5: '铜螺母',
  6: '精打磨',
  7: '喷漆',
  8: '硬度',
  9: '螺纹CNC',
  10: '氧化CNC',
  11: '喷砂CNC',
  12: '配件CNC',
  13: '装配CNC',
}

export function getFollowCraftTypeLabel (type) {
  if (type == null || type === '') return ''
  const s = String(type).trim()
  if (s === '') return ''
  if (FOLLOW_CRAFT_TYPE_LABELS[s] != null) {
    return FOLLOW_CRAFT_TYPE_LABELS[s]
  }
  const n = parseInt(s, 10)
  if (!Number.isNaN(n) && FOLLOW_CRAFT_TYPE_LABELS[n] != null) {
    return FOLLOW_CRAFT_TYPE_LABELS[n]
  }
  return ''
}
